<template>
    <v-btn
        color="primary"
        active
        :disabled="!temPermissaoEdicao"
        @click="novoDocumento">
        <v-icon small>add_circle</v-icon>
        Adicionar
    </v-btn>
</template>

<script>
    import AzHasPermissions from '@azinformatica/loki/src/utils/AzHasPermissions'

    export default {
        name: 'BotaoNovoDocumento',
        methods: {
            novoDocumento() {
                this.$emit('novoDocumento')
            }
        },
        computed: {
            temPermissaoEdicao() {
                return AzHasPermissions(this.$store.state.loki.user.authorities, ['Patrimonio.Normal'])
            },
        }
    }
</script>
